import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Route } from 'react-router-dom'
import Nav from "./container/layouts/nav";
import "./container/index.css";
import "./container/chart.css";
import "./container/step.css";
// import HelmetComponent from './HelmetComponent'

// const mapStateToProps = state => ({
//     isLoggedIn: state.isLoggedIn,
// })

const PrivateRoute = ({ component: Component, ...rest }) => {
    const parseJwt = (token) => {
      try {
        return JSON.parse(atob(token.split(".")[1]));
      } catch (e) {
        return null;
      }
    };
    let localStorageItem = localStorage.getItem("bgToken");
    const decodedJwt = parseJwt(localStorageItem);
    if (decodedJwt && decodedJwt.exp * 1000 < Date.now()) {
      localStorage.removeItem("bgToken");
      localStorage.removeItem("login");
      localStorage.removeItem("userType");
      localStorage.removeItem("profilepic");
      return (
        <Redirect
          to={{
            pathname: "/login",
          }}
        />
      );
    }
   
    return (
        <Route onEnter={() => window.analytics()} {...rest} render={props => (
            localStorage.getItem("login") ? (
                <div
        id={`${localStorage.getItem("login") ? "main-wrapper" : ""}`}
        className={`${localStorage.getItem("login") ? "show menu-toggle" : "mh100vh"} `}
      >
                <Nav />
                <div className={`${localStorage.getItem("login") ? "content-body" : ""}`}>
                    <div
                      className={`${localStorage.getItem("login") ? "container-fluid" : ""}`}
                      style={{ minHeight: window.screen.height - 60 }}
                    >
                <Component {...props} />
                </div></div></div>
                ) :
                <Redirect to={{
                    pathname: '/login',
                    state: { from: props.location }
                    }}/>
        )}/>
    )
}

export default PrivateRoute
